import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { isNilOrEmptyString } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import ToggleButton from 'components/atoms/GefMui/ToggleButton';
import { codelists } from 'constants/codelists';
import { setFeedback } from 'features/views/semaphore/actions';
import { getFeedbackByRecordId } from 'features/views/semaphore/selectors';
import { getContextUser } from 'features/views/userContext/selectors';
import { getCodelistByName } from 'utils';

export const SemaphoreFeedback = ({ type, record, onClickFn }) => {
	const { feedback } = record;
	const dispatch = useDispatch();

	const feedbackCodelist = useSelector(getCodelistByName(codelists.semaphoreFeedback));
	const currentlySelectedFeedback = useSelector((state) => getFeedbackByRecordId(state, record.partnerId));

	useEffect(() => {
		if (type === 'fullFeedback') {
			// to initialize feedback value from the ccd in the "full version" of feedback
			dispatch(setFeedback(record.partnerId, feedback.feedbackId));
		}
		// eslint-disable-next-line
	}, [dispatch]);

	const contextUser = useSelector(getContextUser);
	const viewedAsSubordinateUser = !isNilOrEmptyString(contextUser);

	const feedbackValue = type === 'quickFeedback' ? feedback.feedbackId : currentlySelectedFeedback;

	const handleClick = useCallback(
		(record, feedbackState) => () => {
			dispatch(onClickFn(record, feedbackState));
		},
		[dispatch, onClickFn],
	);
	return (
		<Stack direction="row" spacing={2}>
			{feedbackCodelist.map((feedbackState) => {
				return (
					<ToggleButton
						key={feedbackState.id}
						label={feedbackState.description}
						onClick={handleClick(record, feedbackState)}
						selected={Number(feedbackState.id) === feedbackValue}
						disabled={viewedAsSubordinateUser}
						clickableWhenSelected
					/>
				);
			})}
		</Stack>
	);
};

SemaphoreFeedback.propTypes = {
	onClickFn: PropTypes.func,
	record: PropTypes.object,
	type: PropTypes.oneOf(['fullFeedback', 'quickFeedback']),
};

export default SemaphoreFeedback;
